
    class ShippingRate extends HTMLElement {
      constructor() {
          super();
          this.attachShadow({ mode: 'open' });
            var storedCost = localStorage.getItem("shippingCost");

            if(!storedCost){
              let randomShippingCost = (Math.random() * (3.9 - 2.9) + 2.9).toFixed(2);
              localStorage.setItem("shippingCost", randomShippingCost);
              storedCost = localStorage.getItem("shippingCost");              
            }
            storedCost = localStorage.getItem("shippingCost");
          const wrapper = document.createElement('span');
          wrapper.textContent = storedCost;          
          this.shadowRoot.appendChild(wrapper);
      }

      connectedCallback() {
          console.log('ShippingRate element added to the DOM.');
      }  
      disconnectedCallback() {
          console.log('ShippingRate element removed from the DOM.');
      }
  }
  
  customElements.define('shipping-rate', ShippingRate);